// Column field names
export const COLUMN_FIELDS = {
  INSTRUMENT_STATUS: 'instrument_status',
  OTC_TYPE: 'instrument_type',
  ILLIO_NAME: 'illio_name',
  CODE: 'code',
  CURRENCY: 'currency',
  PNL: 'pnl',
};

// Column header names
export const COLUMN_HEADERS = {
  OTC_TYPE: 'OTC Type',
  ILLIO_NAME: 'Illio Name',
  CODE: 'Code',
  CURRENCY: 'Currency',
  OTC_TITLE: 'OTC Assets',
  OTC_SUBTITLE: 'View all OTC assets',
  SEARCH_PLACEHOLDER: 'Search OTC assets...',
  ADD_NEW_COLUMN: 'Add New Column',
  UPLOAD_TO_ILLIO: 'Upload To Illio',
  OTC_VALUES_UPDATED: 'OTC values updated',
  ILLIO_UPDATED: 'Illio has been updated',
  UPLOAD_SUCCESS: (count: number) =>
    `Successfully uploaded ${count} changed rows to Illio`,
  UPDATE_SUCCESS: (count: number, name: string) =>
    `Updated ${count} OTC date values for ${name}`,
  UPDATE_ERROR: 'Failed to update OTC data',
};

export const BASE_COLUMN_FIELDS = [
  COLUMN_FIELDS.INSTRUMENT_STATUS,
  COLUMN_FIELDS.OTC_TYPE,
  COLUMN_FIELDS.ILLIO_NAME,
  COLUMN_FIELDS.CODE,
  COLUMN_FIELDS.CURRENCY,
  COLUMN_FIELDS.PNL,
];

// Column widths
export const COLUMN_WIDTHS = {
  DEFAULT: 170,
  NARROW: 120,
};

// Date formats
export const DATE_FORMATS = {
  YYYY_MM_DD_REGEX: /^\d{4}-\d{2}-\d{2}$/,
  DD_MM_YYYY_REGEX: /^\d{2}-\d{2}-\d{4}$/,
};

// CSS classes
export const CSS_CLASSES = {
  HIGHLIGHTED_CELL_ADDED: 'highlighted-cell-added',
  HIGHLIGHTED_CELL_REMOVED: 'highlighted-cell-removed',
  HIGHLIGHTED_CELL_CHANGED: 'highlighted-cell-changed',
};

// Default properties
export const DEFAULT_PROPS = {
  DECIMAL_PLACES: 4,
};
